import type { RunProgress, RunningTask } from '../lib/data';

export function latestProgressForRun(
  run: RunningTask | null,
  rows: readonly RunProgress[],
): RunProgress | null {
  if (run === null) return null;
  return rows
    .filter((row) => row.assignment_id === run.assignment_id)
    .reduce<RunProgress | null>((latest, row) => latest === null || row.seq > latest.seq ? row : latest, null);
}

/** The existing ephemeral run-progress row, shown only while its run is still active. */
export function RunProgressLine({ progress }: { readonly progress: RunProgress | null }) {
  if (progress === null) return null;
  return (
    <p className="muted worker-running-progress" aria-live="polite" data-testid="worker-running-progress">
      <strong>Progress</strong> · {progress.tail}
    </p>
  );
}
